/* eslint-disable import/prefer-default-export */

import types from '../constants';

export function setLiveNotificationVariable(isOpenVar) {
  return {
    type: types.SET_NOTIF_STATUS,
    payload: {
      isOpen: isOpenVar
    }
  };
}
